// Multi-currency helpers. Monetary values from the rollup are EUR-canonical
// (converted server-side via each row's fx_to_eur), and these convert EUR into a
// display currency.
//
// The rates are NOT defined here. They live in `fx_rates`, refreshed daily from
// the ECB by `ingest/sync_fx.py`, and reach the app through `useReference().
// fxRates`. A copy in the frontend went stale the moment the table was updated
// and silently reported every non-euro figure ~7% off, so there is deliberately
// nothing to drift from any more.
import type { CurrencyCode, Region } from "@/lib/api/types";

export const SYMBOL: Record<CurrencyCode, string> = { EUR: "€", USD: "$", CAD: "C$" };
export const MARKET_CURRENCY: Record<Region, CurrencyCode> = { EU: "EUR", US: "USD", CA: "CAD" };
export const CURRENCIES: CurrencyCode[] = ["EUR", "USD", "CAD"];

/** 1 unit of `code` = this many EUR, from the live fx_rates table. */
export type FxMap = Partial<Record<CurrencyCode, number>>;

export function fxMap(rows: { currency: string; to_eur: number }[]): FxMap {
  const map: FxMap = { EUR: 1 };
  for (const row of rows) map[row.currency as CurrencyCode] = Number(row.to_eur);
  return map;
}
